import {
  ActionsCompletedEditPageComponent,
  ActionsEditPageComponent,
  AssistanceEditPageComponent,
  CommentEditPageComponent,
  EffectsEditPageComponent,
  InherentRiskEditPageComponent,
  InstallationAniloxEditPageComponent,
  InstallationBobstAttendeesEditPageComponent,
  InstallationBobstContactEditPageComponent,
  InstallationCheckedEditPageComponent,
  InstallationCommentsEditPageComponent,
  InstallationCustomerAttendeesEditPageComponent,
  InstallationCustomerCommentsEditPageComponent,
  InstallationCustomerContactEditPageComponent,
  InstallationCustomerInfoEditPageComponent,
  InstallationDateEditPageComponent,
  InstallationDimensionEditPageComponent,
  InstallationDistanceEditPageComponent,
  InstallationDurationEditPageComponent,
  InstallationEquipmentInfoEditPageComponent,
  InstallationExecutiveSummaryEditPageComponent,
  InstallationFormfileEditPageComponent,
  InstallationFreeTextEditPageComponent,
  InstallationGroundLevelEditPageComponent,
  InstallationIncotermsEditPageComponent,
  InstallationInspectionInfoEditPageComponent,
  InstallationJobProducedEditPageComponent,
  InstallationLubricantEditPageComponent,
  InstallationObservationPluginPageComponent,
  InstallationPartyBccBsaEditPageComponent,
  InstallationPreparationNeededEditPageComponent,
  InstallationReceivedEditPageComponent,
  InstallationRoadSurfaceEditPageComponent,
  InstallationSignatureEditPageComponent,
  InstallationStaffEditPageComponent,
  InstallationStatusEditPageComponent,
  InstallationTrainingProvidedEditPageComponent,
  InstallationVoltageEditPageComponent,
  InstallationWeightEditPageComponent,
  InstallationYesNoEditPageComponent,
  InterventionTasksEditPageComponent,
  MachineSafetyEditPageComponent,
  ReportAdviseEditPageComponent,
  ScoreEditPageComponent,
  SpoTrainPluginPageComponent
} from '..';
import { RouterModule, Routes } from '@angular/router';

import { ActionParticipantsEditPageComponent } from '..';
import { AddPluginPageComponent } from '..';
import { AssociateEquipmentEditPageComponent } from '..';
import { AssociateEquipmentSelectComponent } from '..';
import { AttachementDeletePageComponent } from '..';
import { AttachementUploadPageComponent } from '..';
import { BarreDePincesLockingCheckPluginPageComponent } from '..';
import { BoxesEditPageComponent } from '..';
import { CategoriesEditPageComponent } from '..';
import { ContactEditPageComponent } from '..';
import { CounterEditPageComponent } from '..';
import { CounterPressureCylinderPluginPageComponent } from '..';
import { CustomerRemarkEditPageComponent } from '..';
import { CustomerSelectorEditPageComponent } from '..';
import { CyclesEditPageComponent } from '..';
import { CylindricalParallelismPluginPageComponent } from '..';
import { DateEditPageComponent } from '..';
import { DiscussionEditPageComponent } from '..';
import { ExecutiveSummaryEditPageComponent } from '..';
import { FileAndSuggestionEditPageComponent } from '..';
import { FileAndSuggestionEditSuggestionPageComponent } from '..';
import { FileEditPageComponent } from '..';
import { FileManagerEditPageComponent } from '..';
import { FileUploadPageComponent } from '..';
import { FilesAndSuggestionUploadPageComponent } from '..';
import { InspectionInfoEditPageComponent } from '..';
import { InspectionResolver } from '../../utils/inspection.resolver';
import { JobAnalysisEditPageComponent } from '..';
import { MachineSelectorEditPageComponent } from '..';
import { MarketingPluginPageComponent } from '..';
import { NgModule } from '@angular/core';
import { ObservationsAndRecommandationsPluginPageComponent } from '..';
import { ObsolescencesEditPageComponent } from '../obsolescences/obsolescences-edit.component';
import { OptimisationMachineSelectorEditPageComponent } from '..';
import { ParticipantsAddPageComponent } from '..';
import { ParticipantsEditPageComponent } from '..';
import { PartsAddPageComponent } from '..';
import { PartsEditPageComponent } from '..';
import { PeripheralInfoEditPageComponent } from '..';
import { PhotoAnnotationPageComponent } from '..';
import { PhotoEditPageComponent } from '..';
import { PluginEditComponent } from '../components/edit.component';
import { PluginEditJsonPageComponent } from '../pages/edit-json.component';
import { PluginEditPageComponent } from '../pages/edit.component';
import { RecommendedPartsEditPageComponent } from '..';
import { RepairDaysEditPageComponent } from '..';
import { ResponseBooleanEditPageComponent } from '..';
import { ResponseDateEditPageComponent } from '..';
import { ResponseNumberEditPageComponent } from '..';
import { SoftwareInfoEditPageComponent } from '..';
import { SpoLockingPluginPageComponent } from '..';
import { StatesEditPageComponent } from '..';
import { SynchronizationResolver } from '../../utils/syncronization.resolver';
import { TimeCounterEditPageComponent } from '..';
import { TimeSheetEditPageComponent } from '..';
import { TimeToRepairEditPageComponent } from '..';
import { TotalTimeToRepairEditPageComponent } from '..';
import { TrainingProposalsEditPageComponent } from '..';
import { UpgradesEditPageComponent } from '../upgrades/upgrades-edit.component';
import { environment } from '../../../environments/environment';

const appRoute = environment.applicationRoute;
const inspectionsRoute = appRoute + '/inspections/';
const actionPlansRoute = appRoute + '/actionplans/';
const templatesRoute = appRoute + '/templates/';

const pluginChildRoutes: Routes = [
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/actionscompleted/edit',
    component: ActionsCompletedEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/comment/edit',
    component: CommentEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/reportadviseremarks/edit',
    component: ReportAdviseEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/assistance/edit',
    component: AssistanceEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/customerremark/edit',
    component: CustomerRemarkEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/bardepinceslockingcheck/edit',
    component: BarreDePincesLockingCheckPluginPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/spolocking/edit',
    component: SpoLockingPluginPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/marketing/edit',
    component: MarketingPluginPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/cylindricalparallelism/edit',
    component: CylindricalParallelismPluginPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/counterpressurecylinder/edit',
    component: CounterPressureCylinderPluginPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/states/edit',
    component: StatesEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/timetorepair/edit',
    component: TimeToRepairEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/plugins/:pluginId/totaltimetorepair/edit',
    component: TotalTimeToRepairEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/counter/edit',
    component: CounterEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/boxes/edit',
    component: BoxesEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/cycles/edit',
    component: CyclesEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/softwareinfo/edit',
    component: SoftwareInfoEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/interventiontasks/edit',
    component: InterventionTasksEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/timecounter/edit',
    component: TimeCounterEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/parts/edit',
    component: PartsEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/file/:assetId/edit',
    component: FileEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/file/:assetId/edit/photo',
    component: PhotoEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/file/:assetId/annotate/photo',
    component: PhotoAnnotationPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/files/add',
    component: FileUploadPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/plugins/:pluginId/machineselector/edit',
    component: MachineSelectorEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/plugins/:pluginId/optimisationmachineselector/edit',
    component: OptimisationMachineSelectorEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/plugins/:pluginId/customerselector/edit',
    component: CustomerSelectorEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/plugins/:pluginId/inspectionInfo/edit',
    component: InspectionInfoEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/observationsandrecommandations/edit',
    component: ObservationsAndRecommandationsPluginPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/spotrain/edit',
    component: SpoTrainPluginPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/machinesafety/edit',
    component: MachineSafetyEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/score/edit',
    component: ScoreEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/actions/edit',
    component: ActionsEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/effects/edit',
    component: EffectsEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/inherentrisk/edit',
    component: InherentRiskEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/parentplugin/:pluginId/addPlugin',
    component: AddPluginPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/addPlugin/:applicationSubType',
    component: AddPluginPageComponent
  },
  { path: inspectionsRoute + ':inspectionId/addPlugin/:applicationSubType', component: AddPluginPageComponent },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/fileandsuggestion/:assetId/edit',
    component: FileAndSuggestionEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/fileandsuggestion/:assetId/edit/photo',
    component: PhotoEditPageComponent
  },
  {
    path:
      inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/fileandsuggestion/:assetId/annotate/photo',
    component: PhotoAnnotationPageComponent
  },
  {
    path:
      inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/fileandsuggestion/:assetId/editsuggestion',
    component: FileAndSuggestionEditSuggestionPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/filesandsuggestions/add',
    component: FilesAndSuggestionUploadPageComponent
  },
  { path: inspectionsRoute + ':inspectionId/plugins/:pluginId/contact/edit', component: ContactEditPageComponent },
  {
    path: inspectionsRoute + ':inspectionId/plugins/:pluginId/trainingproposals/edit',
    component: TrainingProposalsEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/plugins/:pluginId/executivesummary/edit',
    component: ExecutiveSummaryEditPageComponent
  },
  { path: inspectionsRoute + ':inspectionId/plugins/:pluginId/timesheet/edit', component: TimeSheetEditPageComponent },
  {
    path: actionPlansRoute + ':actionPlanId/actionplanitems/:actionPlanItemId/plugins/:pluginId/discussion/add',
    component: DiscussionEditPageComponent
  },
  {
    path:
      actionPlansRoute + ':actionPlanId/actionplanitems/:actionPlanItemId/plugins/:pluginId/discussion/:commentId/edit',
    component: DiscussionEditPageComponent
  },
  {
    path: actionPlansRoute + ':actionPlanId/actionplanitems/:actionPlanItemId/plugins/:pluginId/date/edit',
    component: DateEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/attachements/add',
    component: AttachementUploadPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/attachements/:assetId/delete',
    component: AttachementDeletePageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/plugins/:pluginId/jobanalysis/edit',
    component: JobAnalysisEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/plugins/:pluginId/peripheralinfo/edit',
    component: PeripheralInfoEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/plugins/:pluginId/recommendedparts/edit',
    component: RecommendedPartsEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/plugins/:pluginId/associateequipment/edit',
    component: AssociateEquipmentEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/plugins/:pluginId/associateequipment/select',
    component: AssociateEquipmentSelectComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/parts/addPart/:equipmentId',
    component: PartsAddPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/parts/import',
    component: PartsAddPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/parts/edit/:partId',
    component: PartsAddPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/editjson',
    component: PluginEditJsonPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/edit',
    component: PluginEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/plugins/:pluginId/repairdays/edit',
    component: RepairDaysEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/filemanager/edit',
    component: FileManagerEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/plugins/:pluginId/participants/edit',
    component: ParticipantsEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/plugins/:pluginId/participants/add',
    component: ParticipantsAddPageComponent
  },
  {
    path: actionPlansRoute + ':actionPlanId/actionplanitems/:actionPlanItemId/plugins/:pluginId/participants/edit',
    component: ActionParticipantsEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/responseboolean/edit',
    component: ResponseBooleanEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/responsenumber/edit',
    component: ResponseNumberEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/responsedate/edit',
    component: ResponseDateEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/anilox/edit',
    component: InstallationAniloxEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/partybccbsa/edit',
    component: InstallationPartyBccBsaEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/bobstattendees/edit',
    component: InstallationBobstAttendeesEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/plugins/:pluginId/installation/bobstattendees/edit',
    component: InstallationBobstAttendeesEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/plugins/:pluginId/installation/bobstcontact/edit',
    component: InstallationBobstContactEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/checked/edit',
    component: InstallationCheckedEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/customerattendees/edit',
    component: InstallationCustomerAttendeesEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/plugins/:pluginId/installation/customerattendees/edit',
    component: InstallationCustomerAttendeesEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/plugins/:pluginId/installation/customercomments/edit',
    component: InstallationCustomerCommentsEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/customercomments/edit',
    component: InstallationCustomerCommentsEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/plugins/:pluginId/installation/customercontact/edit',
    component: InstallationCustomerContactEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/plugins/:pluginId/installation/customerinfo/edit',
    component: InstallationCustomerInfoEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/dimension/edit',
    component: InstallationDimensionEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/distance/edit',
    component: InstallationDistanceEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/duration/edit',
    component: InstallationDurationEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/plugins/:pluginId/installation/equipmentinfo/edit',
    component: InstallationEquipmentInfoEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/freetext/edit',
    component: InstallationFreeTextEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/groundlevel/edit',
    component: InstallationGroundLevelEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/incoterms/edit',
    component: InstallationIncotermsEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/plugins/:pluginId/installation/comments/edit',
    component: InstallationCommentsEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/comments/edit',
    component: InstallationCommentsEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/date/edit',
    component: InstallationDateEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/plugins/:pluginId/installation/inspectioninfo/edit',
    component: InstallationInspectionInfoEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/lubricant/edit',
    component: InstallationLubricantEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/preparationneeded/edit',
    component: InstallationPreparationNeededEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/received/edit',
    component: InstallationReceivedEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/roadsurface/edit',
    component: InstallationRoadSurfaceEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/signature/edit',
    component: InstallationSignatureEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/staff/edit',
    component: InstallationStaffEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/status/edit',
    component: InstallationStatusEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/voltage/edit',
    component: InstallationVoltageEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/weight/edit',
    component: InstallationWeightEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/yesno/edit',
    component: InstallationYesNoEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/jobproduced/edit',
    component: InstallationJobProducedEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/trainingprovided/edit',
    component: InstallationTrainingProvidedEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/formfile/edit',
    component: InstallationFormfileEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/plugins/:pluginId/installation/executivesummary/edit',
    component: InstallationExecutiveSummaryEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/observation/edit',
    component: InstallationObservationPluginPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/upgrades/edit',
    component: UpgradesEditPageComponent
  },
  {
    path: inspectionsRoute + ':inspectionId/points/:pointId/plugins/:pluginId/obsolescences/edit',
    component: ObsolescencesEditPageComponent
  },

  // templates routes
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/actionscompleted/edit',
    component: ActionsCompletedEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/comment/edit',
    component: CommentEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/reportadvise/edit',
    component: ReportAdviseEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/assistance/edit',
    component: AssistanceEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/customerremark/edit',
    component: CustomerRemarkEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/bardepinceslockingcheck/edit',
    component: BarreDePincesLockingCheckPluginPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/spolocking/edit',
    component: SpoLockingPluginPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/cylindricalparallelism/edit',
    component: CylindricalParallelismPluginPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/counterpressurecylinder/edit',
    component: CounterPressureCylinderPluginPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/states/edit',
    component: StatesEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/timetorepair/edit',
    component: TimeToRepairEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/totaltimetorepair/edit',
    component: TotalTimeToRepairEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/counter/edit',
    component: CounterEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/boxes/edit',
    component: BoxesEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/cycles/edit',
    component: CyclesEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/softwareinfo/edit',
    component: SoftwareInfoEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/interventiontasks/edit',
    component: InterventionTasksEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/timecounter/edit',
    component: TimeCounterEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/parts/edit',
    component: PartsEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/parts/addPart/:equipmentId',
    component: PartsAddPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/parts/import',
    component: PartsAddPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/parts/edit/:partId',
    component: PartsAddPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/file/:assetId/edit',
    component: FileEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/files/add',
    component: FileUploadPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/fileandsuggestion/:assetId/edit',
    component: FileAndSuggestionEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/fileandsuggestion/:assetId/edit/photo',
    component: PhotoEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/fileandsuggestion/:assetId/annotate/photo',
    component: PhotoAnnotationPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/fileandsuggestion/:assetId/editsuggestion',
    component: FileAndSuggestionEditSuggestionPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/filesandsuggestions/add',
    component: FilesAndSuggestionUploadPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/plugins/:pluginId/machineselector/edit',
    component: MachineSelectorEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/plugins/:pluginId/optimisationmachineselector/edit',
    component: OptimisationMachineSelectorEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/plugins/:pluginId/customerselector/edit',
    component: CustomerSelectorEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/spotrain/edit',
    component: SpoTrainPluginPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/machinesafety/edit',
    component: MachineSafetyEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/score/edit',
    component: ScoreEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/actions/edit',
    component: ActionsEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/effects/edit',
    component: EffectsEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/inherentrisk/edit',
    component: InherentRiskEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/plugins/:pluginId/inspectionInfo/edit',
    component: InspectionInfoEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/parentplugin/:pluginId/addPlugin',
    component: AddPluginPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/addPlugin/:applicationSubType',
    component: AddPluginPageComponent
  },
  { path: templatesRoute + ':inspectionId/addPlugin/:applicationSubType', component: AddPluginPageComponent },
  { path: templatesRoute + ':inspectionId/categories/edit', component: CategoriesEditPageComponent },
  { path: templatesRoute + ':inspectionId/plugins/:pluginId/contact/edit', component: ContactEditPageComponent },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/observationsandrecommandations/edit',
    component: ObservationsAndRecommandationsPluginPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/plugins/:pluginId/trainingproposals/edit',
    component: TrainingProposalsEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/plugins/:pluginId/executivesummary/edit',
    component: ExecutiveSummaryEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/attachements/add',
    component: AttachementUploadPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/attachements/:assetId/delete',
    component: AttachementDeletePageComponent
  },
  {
    path: templatesRoute + ':inspectionId/plugins/:pluginId/jobanalysis/edit',
    component: JobAnalysisEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/plugins/:pluginId/peripheralinfo/edit',
    component: PeripheralInfoEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/plugins/:pluginId/recommendedparts/edit',
    component: RecommendedPartsEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/editjson',
    component: PluginEditJsonPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/edit',
    component: PluginEditPageComponent
  },
  { path: templatesRoute + ':inspectionId/plugins/:pluginId/repairdays/edit', component: RepairDaysEditPageComponent },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/filemanager/edit',
    component: FileManagerEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/plugins/:pluginId/participants/edit',
    component: ParticipantsEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/plugins/:pluginId/participants/add',
    component: ParticipantsAddPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/responseboolean/edit',
    component: ResponseBooleanEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/responsenumber/edit',
    component: ResponseNumberEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/responsedate/edit',
    component: ResponseDateEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/marketing/edit',
    component: MarketingPluginPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/anilox/edit',
    component: InstallationAniloxEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/partybccbsa/edit',
    component: InstallationPartyBccBsaEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/bobstattendees/edit',
    component: InstallationBobstAttendeesEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/plugins/:pluginId/installation/bobstattendees/edit',
    component: InstallationBobstAttendeesEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/plugins/:pluginId/installation/bobstcontact/edit',
    component: InstallationBobstContactEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/checked/edit',
    component: InstallationCheckedEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/customerattendees/edit',
    component: InstallationCustomerAttendeesEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/plugins/:pluginId/installation/customerattendees/edit',
    component: InstallationCustomerAttendeesEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/plugins/:pluginId/installation/customercomments/edit',
    component: InstallationCustomerCommentsEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/customercomments/edit',
    component: InstallationCustomerCommentsEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/plugins/:pluginId/installation/customercontact/edit',
    component: InstallationCustomerContactEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/plugins/:pluginId/installation/customerinfo/edit',
    component: InstallationCustomerInfoEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/dimension/edit',
    component: InstallationDimensionEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/distance/edit',
    component: InstallationDistanceEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/duration/edit',
    component: InstallationDurationEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/plugins/:pluginId/installation/equipmentinfo/edit',
    component: InstallationEquipmentInfoEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/freetext/edit',
    component: InstallationFreeTextEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/groundlevel/edit',
    component: InstallationGroundLevelEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/incoterms/edit',
    component: InstallationIncotermsEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/plugins/:pluginId/installation/comments/edit',
    component: InstallationCommentsEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/comments/edit',
    component: InstallationCommentsEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/date/edit',
    component: InstallationDateEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/plugins/:pluginId/installation/inspectioninfo/edit',
    component: InstallationInspectionInfoEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/lubricant/edit',
    component: InstallationLubricantEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/preparationneeded/edit',
    component: InstallationPreparationNeededEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/received/edit',
    component: InstallationReceivedEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/roadsurface/edit',
    component: InstallationRoadSurfaceEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/signature/edit',
    component: InstallationSignatureEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/staff/edit',
    component: InstallationStaffEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/status/edit',
    component: InstallationStatusEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/voltage/edit',
    component: InstallationVoltageEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/weight/edit',
    component: InstallationWeightEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/yesno/edit',
    component: InstallationYesNoEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/jobproduced/edit',
    component: InstallationJobProducedEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/trainingprovided/edit',
    component: InstallationTrainingProvidedEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/formfile/edit',
    component: InstallationFormfileEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/plugins/:pluginId/installation/executivesummary/edit',
    component: InstallationExecutiveSummaryEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/installation/observation/edit',
    component: InstallationObservationPluginPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/upgrades/edit',
    component: UpgradesEditPageComponent
  },
  {
    path: templatesRoute + ':inspectionId/points/:pointId/plugins/:pluginId/obsolescences/edit',
    component: ObsolescencesEditPageComponent
  }
];

const routes: Routes = [
  {
    path: '',
    resolve: { synchronizeData: SynchronizationResolver, inspection: InspectionResolver },
    children: pluginChildRoutes
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  declarations: [],
  exports: [RouterModule]
})
export class PluginRoutingModule {}

export const routedComponents = [
  ActionsCompletedEditPageComponent,
  CommentEditPageComponent,
  ReportAdviseEditPageComponent,
  AssistanceEditPageComponent,
  FileEditPageComponent,
  FileUploadPageComponent,
  MachineSelectorEditPageComponent,
  CustomerSelectorEditPageComponent,
  AddPluginPageComponent,
  BarreDePincesLockingCheckPluginPageComponent,
  CylindricalParallelismPluginPageComponent,
  CounterPressureCylinderPluginPageComponent,
  StatesEditPageComponent,
  TimeToRepairEditPageComponent,
  TotalTimeToRepairEditPageComponent,
  PartsEditPageComponent,
  CounterEditPageComponent,
  TimeCounterEditPageComponent,
  CyclesEditPageComponent,
  SoftwareInfoEditPageComponent,
  BoxesEditPageComponent,
  InspectionInfoEditPageComponent,
  CustomerRemarkEditPageComponent,
  ContactEditPageComponent,
  ObservationsAndRecommandationsPluginPageComponent,
  FileAndSuggestionEditPageComponent,
  FilesAndSuggestionUploadPageComponent,
  FileAndSuggestionEditSuggestionPageComponent,
  TrainingProposalsEditPageComponent,
  ExecutiveSummaryEditPageComponent,
  TimeSheetEditPageComponent,
  DiscussionEditPageComponent,
  PhotoEditPageComponent,
  PhotoAnnotationPageComponent,
  OptimisationMachineSelectorEditPageComponent,
  AttachementUploadPageComponent,
  AttachementDeletePageComponent,
  JobAnalysisEditPageComponent,
  PeripheralInfoEditPageComponent,
  PartsAddPageComponent,
  CategoriesEditPageComponent,
  RecommendedPartsEditPageComponent,
  AssociateEquipmentEditPageComponent,
  AssociateEquipmentSelectComponent,
  PluginEditJsonPageComponent,
  RepairDaysEditPageComponent,
  DiscussionEditPageComponent,
  DateEditPageComponent,
  FileManagerEditPageComponent,
  ParticipantsEditPageComponent,
  ParticipantsAddPageComponent,
  ActionParticipantsEditPageComponent,
  ResponseDateEditPageComponent,
  ResponseNumberEditPageComponent,
  ResponseBooleanEditPageComponent,
  SpoLockingPluginPageComponent,
  MarketingPluginPageComponent,
  InterventionTasksEditPageComponent,
  PluginEditComponent,
  PluginEditPageComponent,
  UpgradesEditPageComponent,
  ObsolescencesEditPageComponent,
  SpoTrainPluginPageComponent,
  MachineSafetyEditPageComponent,
  ScoreEditPageComponent,
  ActionsEditPageComponent,
  EffectsEditPageComponent,
  InherentRiskEditPageComponent,

  //installation components
  InstallationAniloxEditPageComponent,
  InstallationPartyBccBsaEditPageComponent,
  InstallationBobstAttendeesEditPageComponent,
  InstallationBobstContactEditPageComponent,
  InstallationCheckedEditPageComponent,
  InstallationCustomerAttendeesEditPageComponent,
  InstallationCustomerCommentsEditPageComponent,
  InstallationCustomerContactEditPageComponent,
  InstallationCustomerInfoEditPageComponent,
  InstallationDimensionEditPageComponent,
  InstallationDistanceEditPageComponent,
  InstallationDurationEditPageComponent,
  InstallationEquipmentInfoEditPageComponent,
  InstallationFreeTextEditPageComponent,
  InstallationGroundLevelEditPageComponent,
  InstallationIncotermsEditPageComponent,
  InstallationCommentsEditPageComponent,
  InstallationDateEditPageComponent,
  InstallationInspectionInfoEditPageComponent,
  InstallationLubricantEditPageComponent,
  InstallationPreparationNeededEditPageComponent,
  InstallationReceivedEditPageComponent,
  InstallationRoadSurfaceEditPageComponent,
  InstallationSignatureEditPageComponent,
  InstallationStaffEditPageComponent,
  InstallationStatusEditPageComponent,
  InstallationVoltageEditPageComponent,
  InstallationWeightEditPageComponent,
  InstallationYesNoEditPageComponent,
  InstallationExecutiveSummaryEditPageComponent,
  InstallationFormfileEditPageComponent
];
